import { reducer as reduxFormReducer } from 'redux-form';
import createReduxStore from 'helpers/create-redux-store';

import openginsDirectoryDspReducer from './components/openings-directory-dsp/reducer';
import openingsDirectoryIndexReducer from './components/openings-directory-index/reducer';
import portalEmailConfirmationReducer from './components/portal-email-confirmation/reducer';

export default createReduxStore(
  { form: reduxFormReducer },
  openginsDirectoryDspReducer,
  openingsDirectoryIndexReducer,
  portalEmailConfirmationReducer
);
